import {
    Box, Button, Flex, Image, Select, Spinner, Text, Popover,
    PopoverTrigger,
    PopoverContent,
    PopoverHeader,
    PopoverBody,
    PopoverFooter,
    PopoverArrow,
    PopoverCloseButton,
    PopoverAnchor
} from "@chakra-ui/react";
import {useLocation} from "react-router-dom";
import React, {useState} from "react";
import Card from "components/card/Card"
import AspectSensitivity from "./AspectSensitivity";
import SentimentAnalysis from "./SentimentAnalysis";
import {gql, useQuery} from "@apollo/client";
import {DateRangePicker} from 'react-date-range';
import {subYears, format} from 'date-fns';
import {FiCalendar} from "react-icons/fi"
import {ChevronDownIcon} from "@chakra-ui/icons"
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

export function useLocationQuery() {
    const {search} = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
}

export const getProductsForProductFamilyQuery = gql`
    query GetProductsForProductFamily($product_family: String = "") {
      products(where: {product_family: {_eq: $product_family}}) {
        product_platform_id
        product_universal_id
        product_disambiguation
        product_image_url: data(path: "$.product_image_url")
      }
    }
    `

export function processProductFamilyData(data) {
    let product_variants = {"a random universal_ id": {product_disambiguation: "All Variants"}}
    let variant_to_product_ids = {"All Variants": []}
    let image;
    console.log("products", data.products)
    for (let product of data.products) {
        if (image == null) {
            image = product.product_image_url
        }
        variant_to_product_ids["All Variants"].push(product.product_platform_id)

        if (!(product.product_universal_id in product_variants)) {
            product_variants[product.product_universal_id] = {
                product_platform_id: [product.product_platform_id],
                product_disambiguation: product.product_disambiguation
            }
        } else {
            product_variants[product.product_universal_id].product_platform_id.push(product.product_platform_id);
        }
    }
    for (const value of Object.entries(product_variants)) {
        if (value[1].product_disambiguation === "All Variants") continue;
        variant_to_product_ids[value[1].product_disambiguation] = value[1].product_platform_id;
    }
    return {product_variants, variant_to_product_ids, image};
}

function DateRangePickerPopover({dateRangeState, setDateRangeState}) {
    const startDateStr = format(dateRangeState[0].startDate, "dd MMM, yyyy")
    const endDateStr = format(dateRangeState[0].endDate, "dd MMM, yyyy")
    return (
        <Popover>
            <PopoverTrigger>
                <Button borderRadius='100px' mt="10px">
                    <FiCalendar/> <Text ml="10px" mr="10px"
                                        fontWeight='semibold'>{`${startDateStr} - ${endDateStr}`}</Text>
                    <ChevronDownIcon/>
                </Button>
            </PopoverTrigger>
            <PopoverContent w='590px'>
                <PopoverArrow/>
                <PopoverCloseButton/>
                <PopoverHeader>Select the date range to analyze</PopoverHeader>
                <PopoverBody>
                    <DateRangePicker
                        onChange={item => setDateRangeState([item.selection])}
                        showSelectionPreview={false}
                        moveRangeOnFirstSelection={false}
                        months={1}
                        ranges={dateRangeState}
                        direction="horizontal"
                        dateDisplayFormat="d MMM yyyy"
                    />
                </PopoverBody>
            </PopoverContent>
        </Popover>
    )
}

export function VariantSelector({
                                    image,
                                    product_family,
                                    currentVariant,
                                    setCurrentVariant,
                                    product_variants,
                                    dateRangeState,
                                    setDateRangeState,
                                    dateRangePickerEnabled = true
                                }) {

    return (
        <Flex direction='row'>
            <Image
                src={image}
                w='155px'
                objectFit='contain'
                borderRadius='10px'
                me='15px'
                mb={{base: "30px", "2xl": "0px"}}
                sx={{aspectRatio: "1"}}
            />
            <Box>
                <Text fontSize='2xl'
                      fontWeight="bold">{product_family}</Text> {/** Refactor the selector as a higher level component**/}
                <Select value={currentVariant}
                        onChange={(ev) => (setCurrentVariant(ev?.target?.value))}>
                    {Object.entries(product_variants).map(p => <option
                        key={p[0]}> {p[1].product_disambiguation}</option>)}
                </Select>
                {dateRangePickerEnabled ?
                    <DateRangePickerPopover dateRangeState={dateRangeState} setDateRangeState={setDateRangeState}/>
                    : null}
            </Box>
        </Flex>
    )
}

export default function Default(props) {
    let query = useLocationQuery();
    const [currentVariant, setCurrentVariant] = useState("All Variants")
    const [renderReviews, setRenderReviews] = useState(false);
    const [reviewAspect, setReviewAspect] = useState("");
    const [reviewSentiment, setReviewSentiment] = useState("");


    const [dateRangeState, setDateRangeState] = useState([
        {
            startDate: subYears(new Date(), 10),
            endDate: new Date(),
            key: 'selection'
        }
    ]);


    console.log("dateRangeState", dateRangeState);

    //const [selectedProductIds, setSelectedProductIds] = useState([])
    function handleReviewUpdate(aspect, sentiment) {
        console.log("handleReviewUpdate called");
        setRenderReviews(true);
        setReviewAspect(aspect);
        setReviewSentiment(sentiment);
    }

    const product_family = query.get('product_family');
    let {
        loading,
        error,
        data
    } = useQuery(getProductsForProductFamilyQuery, {variables: {"product_family": product_family}})
    if (loading) {
        return <Box pt={{base: "130px", md: "80px", xl: "80px"}}><Spinner/> <Text>Loading...</Text></Box>
    }
    if (error || !data) {
        return (<div>Error... Please refresh to try again</div>);
    }
    let {product_variants, variant_to_product_ids, image} = processProductFamilyData(data)

    return (

        <Flex direction='row' justify="center">
            <Card w="45%" pt={{base: "130px", md: "80px", xl: "80px"}} borderRadius='30px' mt='24px' mr='24px'
            >
                <Flex direction='column'>


                    <VariantSelector image={image} product_family={product_family} currentVariant={currentVariant}
                                     setCurrentVariant={setCurrentVariant} product_variants={product_variants}
                                     setDateRangeState={setDateRangeState} dateRangeState={dateRangeState}/>

                    <SentimentAnalysis productIds={variant_to_product_ids[currentVariant]} renderReviews={renderReviews}
                                       setRenderReviews={setRenderReviews} reviewAspect={reviewAspect}
                                       setReviewAspect={setReviewAspect}
                                       reviewSentiment={reviewSentiment} setReviewSentiment={setReviewSentiment}
                                       handleReviewUpdate={handleReviewUpdate}
                                       startDate={format(dateRangeState[0].startDate, "yyyy-MM-dd")}
                                       endDate={format(dateRangeState[0].endDate, "yyyy-MM-dd")}/>
                </Flex>
            </Card>
            <Card w="45%" mt="24px">
                <AspectSensitivity product_ids={variant_to_product_ids[currentVariant]}
                                   handleReviewUpdate={handleReviewUpdate}/>
            </Card>
        </Flex>
    )
}